import { forwardRef, type Ref, type SVGProps } from "react";
const IconLightBulbOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={10} height={2} x={11} y={25} fill="currentColor" rx={1} />
    <rect width={8} height={2} x={12} y={28} fill="currentColor" rx={1} />
    <path
      fill="currentColor"
      d="M16 4a7.6 7.6 0 0 1 7.8 7.5 7.2 7.2 0 0 1-3.8 6.4l-1 .5V22h-6v-3.6l-1-.5a7.3 7.3 0 0 1-3.8-6.4A7.8 7.8 0 0 1 16.1 4m0-2a9.8 9.8 0 0 0-9.9 9.5 9.3 9.3 0 0 0 4.8 8.1V23a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.4a9.2 9.2 0 0 0 4.8-8.1A9.6 9.6 0 0 0 16 2z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLightBulbOutlineSVG);
ForwardRef.displayName = "IconLightBulbOutline";
export { ForwardRef as IconLightBulbOutline };
